import React from 'react'
import { useText } from '../context/TextContext'
import { getTypeFromDomain } from '../utils/variations';
import { OrganizationType } from '../models/shared/Organization';

const type = getTypeFromDomain()

interface Props {
    light?: boolean;
    size?: 'lg'
}
export default function BrandName(props: Props) {
    const text = useText();

    if (type === OrganizationType.cgh) {
        return <h3 className='m-0 brand-name'>{text.brand}</h3>
    }

    const filePath = props.light ? '/logo_light_slim.png' : '/logo_slim.png';
    let size = 75;
    if (props.size === 'lg') {
        size = 150;
    }
    return (
        <div className='brand-name'>
            <img src={filePath} alt={text.brand} style={{ maxHeight: size, maxWidth: size }} />
        </div>
    )
}
